import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Caption, DifficultyIcon, IntensityIcon, P, Grid } from 'ui/acro'

const PlanDetails = ({
  workoutCount,
  difficulty,
  averageDuration,
  intensity,
  equipment
}) => {
  const renderDuration = () => {
    if (averageDuration === 1) {
      return `${averageDuration} minute`
    } else {
      return `${averageDuration} minutes`
    }
  }

  return (
    <Grid
      maxWidth={[null, null, '425px']}
      gridTemplateColumns='1fr 1fr'
      gridRowGap='10px'
      alignItems='baseline'
    >
      <Caption variant='heavy' color='grey5'>
        Classes
      </Caption>
      <P>{workoutCount}</P>
      {averageDuration && (
        <Fragment>
          <Caption variant='heavy' color='grey5'>
            Average Duration
          </Caption>
          <P>{renderDuration()}</P>
        </Fragment>
      )}
      <Caption variant='heavy' color='grey5'>
        Props
      </Caption>
      <P>{equipment || 'None'}</P>
      {difficulty && (
        <Fragment>
          <Caption variant='heavy' color='grey5'>
            Difficulty
          </Caption>
          <P textTransform='capitalize'>
            <DifficultyIcon difficulty={difficulty} />
          </P>
        </Fragment>
      )}
      {intensity && (
        <Fragment>
          <Caption variant='heavy' color='grey5'>
            Intensity
          </Caption>
          <P>
            <IntensityIcon intensity={intensity} />
          </P>
        </Fragment>
      )}
    </Grid>
  )
}

PlanDetails.propTypes = {
  averageDuration: PropTypes.number,
  intensity: PropTypes.number,
  difficulty: PropTypes.string,
  equipment: PropTypes.string,
  workoutCount: PropTypes.number
}

export default PlanDetails
